import React from 'react';
export const FilePerson = props => (
  <svg viewBox="0 0 20 20" width="16px" height="16px" {...props} className={`btfont ${props.className ? props.className : ''}`}><path d="M12 1a1 1 0 0 1 1 1v10.755S12 11 8 11s-5 1.755-5 1.755V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z" fillRule="evenodd" />,
<path d="M8 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" fillRule="evenodd" /></svg>
);
